var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleLinesEventsMobile(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 456.99,
    height: 411.42,
    viewBox: "0 0 456.99 411.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791",
    transform: "translate(73.133 -52.689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circles_and_lines",
    "data-name": "Circles and lines",
    transform: "translate(5.9 -448.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    transform: "translate(4.928 501)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.805,
    cy: 6.805,
    r: 6.805,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.805,
    cy: 6.805,
    r: 5.805,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    transform: "translate(284.502 642.111)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.014,
    cy: 5.014,
    r: 5.014,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.014,
    cy: 5.014,
    r: 4.014,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    transform: "translate(120.154 579.793)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.805,
    cy: 6.805,
    r: 6.805,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.805,
    cy: 6.805,
    r: 5.805,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    transform: "translate(133.375 525.354)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.581,
    cy: 3.581,
    r: 3.581,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.581,
    cy: 3.581,
    r: 2.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    transform: "translate(-71 501)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.581,
    cy: 3.581,
    r: 3.581,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.581,
    cy: 3.581,
    r: 2.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    transform: "translate(332.247 532.517)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.581,
    cy: 3.581,
    r: 3.581,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.581,
    cy: 3.581,
    r: 2.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    transform: "translate(156.729 682.223)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.805,
    cy: 6.805,
    r: 6.805,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.805,
    cy: 6.805,
    r: 5.805,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x2: 12.893,
    y2: 14.326,
    transform: "translate(57.709 514.968)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    "data-name": "Line 130",
    x2: 12.893,
    y2: 14.326,
    transform: "translate(239.213 726.276)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x1: 12.177,
    y2: 10.744,
    transform: "translate(353.02 579.793)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M-3.222,0l-8.135,19.548",
    transform: "translate(34.35 655.362)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M-11.356,0,.579,17.357",
    transform: "translate(376.554 666.231)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x2: 15.759,
    y2: 4.298,
    transform: "translate(230.169 519.982)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_129",
    "data-name": "Line 129",
    x2: 15.759,
    y2: 4.298,
    transform: "translate(19.262 561.527)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x1: 11.461,
    y2: 13.968,
    transform: "translate(237.87 579.793)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Circles_and_lines-2",
    "data-name": "Circles and lines",
    transform: "translate(-2.133 -227.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_57-2",
    "data-name": "Ellipse 57",
    transform: "translate(4.928 501)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.805,
    cy: 6.805,
    r: 6.805,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.805,
    cy: 6.805,
    r: 5.805,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62-2",
    "data-name": "Ellipse 62",
    transform: "translate(284.502 642.111)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.014,
    cy: 5.014,
    r: 5.014,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.014,
    cy: 5.014,
    r: 4.014,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58-2",
    "data-name": "Ellipse 58",
    transform: "translate(120.154 579.793)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.805,
    cy: 6.805,
    r: 6.805,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.805,
    cy: 6.805,
    r: 5.805,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60-2",
    "data-name": "Ellipse 60",
    transform: "translate(133.375 525.354)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.581,
    cy: 3.581,
    r: 3.581,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.581,
    cy: 3.581,
    r: 2.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_76-2",
    "data-name": "Ellipse 76",
    transform: "translate(-71 501)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.581,
    cy: 3.581,
    r: 3.581,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.581,
    cy: 3.581,
    r: 2.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61-2",
    "data-name": "Ellipse 61",
    transform: "translate(332.247 532.517)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.581,
    cy: 3.581,
    r: 3.581,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.581,
    cy: 3.581,
    r: 2.581,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_59-2",
    "data-name": "Ellipse 59",
    transform: "translate(153.729 655.362)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.805,
    cy: 6.805,
    r: 6.805,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.805,
    cy: 6.805,
    r: 5.805,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_82-2",
    "data-name": "Line 82",
    x2: 12.893,
    y2: 14.326,
    transform: "translate(57.709 514.968)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M0,0,6.447,7.163l6.447,7.163",
    transform: "translate(258.213 676.425)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85-2",
    "data-name": "Line 85",
    x1: 12.177,
    y2: 10.744,
    transform: "translate(353.02 579.793)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125-2",
    "data-name": "Path 1125",
    d: "M-3.222,0l-8.135,19.548",
    transform: "translate(34.35 655.362)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126-2",
    "data-name": "Path 1126",
    d: "M-11.356,0,.579,17.357",
    transform: "translate(376.554 666.231)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84-2",
    "data-name": "Line 84",
    x2: 15.759,
    y2: 4.298,
    transform: "translate(230.169 519.982)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_129-2",
    "data-name": "Line 129",
    x2: 15.759,
    y2: 4.298,
    transform: "translate(19.262 561.527)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86-2",
    "data-name": "Line 86",
    x1: 11.461,
    y2: 13.968,
    transform: "translate(237.87 579.793)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLinesEventsMobile);
export default __webpack_public_path__ + "static/media/circleLinesEventsMobile.18a05df8f12ac516242cd0d29b7c34fe.svg";
export { ForwardRef as ReactComponent };